export const node = {
    SET: "set",

    STRAIGHT: "straight",
    TURNOUT: "turnout",
    UNDEFINED: "undefined",
}